/* Livraison offerte par email (08/10/2026). Données et textes : snippets/rok-ship.liquid.
   1. Un email donné (pop-up, sac, pied de page) ou le lien de bienvenue (?livraison=offerte) ouvre le droit sur cet appareil.
   2. À chaque page, le code est ajouté au panier par /cart/update.js, sans retirer un code créateur.
   3. Les mentions « Livraison 4,90 € » deviennent « Livraison 4,90 € barré, offerte ». Shopify contrôle au paiement (une fois par client).
   Ne modifie pas rok-v2.js : observe le sac et les mentions de livraison qu'il réécrit. */
(() => {
  const dataEl = document.getElementById('rok-ship-data');
  if (!dataEl) return;
  let D; try { D = JSON.parse(dataEl.textContent); } catch { return; }
  const KEY = 'rok-ship', SUB = 'rok-v2-sub';
  const store = {
    get: k => { try { return localStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch {} }
  };
  const on = () => store.get(KEY) === '1';
  const esc = v => String(v).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const json = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET', credentials: 'same-origin',
    headers: {Accept: 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})},
    body: body ? JSON.stringify(body) : undefined
  }).then(r => r.ok ? r.json() : Promise.reject(r));

  /* Ajoute le code au panier s'il n'y est pas ; garde les autres codes (code créateur) */
  let applying = null;
  function apply() {
    if (!on()) return Promise.resolve();
    if (applying) return applying;
    applying = json(D.cart + '.js').then(c => {
      const codes = (c.discount_codes || []).map(d => d.code).filter(Boolean);
      if (codes.some(x => x.toUpperCase() === D.code)) return;
      return json(D.update + '.js', {discount: [...codes, D.code].join(',')});
    }).catch(() => {}).finally(() => { applying = null; });
    return applying;
  }

  /* Affichage : mentions de livraison, bandeau, ligne du sac */
  const announce = document.querySelector('.v2-announce');
  const announceOff = announce ? announce.textContent.replace(/\s+/g, ' ').trim() : '';
  // Même découpage que rok-v2-header.liquid : un span par message (ils alternent sur téléphone)
  const setAnnounce = text => {
    if (announce.dataset.rokText === text) return;
    announce.dataset.rokText = text;
    announce.innerHTML = text.split(' · ').map((m, i) => `${i ? '<span class="v2-announce__sep" aria-hidden="true"> · </span>' : ''}<span class="v2-announce__m" style="--i:${i}">${esc(m)}</span>`).join('');
  };
  let painting = false, mo = null;
  function paint() {
    painting = true;
    const yes = on();
    document.documentElement.classList.toggle('rok-ship-on', yes);
    document.querySelectorAll('[data-v2-ship]').forEach(el => {
      // Comparaison avec ce qu'on a écrit (le navigateur peut réécrire les espaces insécables en entités)
      const want = yes ? D.t.onHtml : esc(D.t.off);
      if (el._rokWant !== want || el.innerHTML !== el._rokSet) { el.innerHTML = want; el._rokWant = want; el._rokSet = el.innerHTML; }
      el.classList.add('rok-ship-line');
    });
    if (announce) setAnnounce(yes ? D.t.announceOn : announceOff);
    const box = document.querySelector('[data-v2-cart-ship]');
    if (box && !box.hidden) {
      const state = yes ? 'on' : 'off';
      if (box.dataset.rokShip !== state) {
        box.dataset.rokShip = state;
        box.classList.add('rok-ship-line');
        if (yes) box.innerHTML = D.t.cartOnHtml;
        else {
          box.innerHTML = `<span>${esc(D.t.cartOff)}</span>`;
          const tpl = document.getElementById('rok-ship-cartform');
          if (tpl) box.appendChild(tpl.content.cloneNode(true));
        }
      }
    }
    painting = false;
    mo?.takeRecords(); // nos propres écritures ne relancent pas l'observateur
  }

  /* rok-v2.js réécrit ces zones (choix du pack, ouverture du sac) : on repasse derrière lui */
  let raf = 0;
  const repaint = () => { if (painting) return; cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); };
  mo = new MutationObserver(muts => {
    if (painting) return;
    // Le sac a été redessiné (ajout, retrait) : sa ligne livraison est à refaire, et le panier peut être nouveau
    if (muts.some(m => m.target.closest?.('[data-v2-cart]'))) {
      const box = document.querySelector('[data-v2-cart-ship]');
      if (box && !box.querySelector('.rok-ship-form') && box.dataset.rokShip === 'off') delete box.dataset.rokShip;
      if (box && box.dataset.rokShip === 'on' && !box.querySelector('b')) delete box.dataset.rokShip;
      apply();
    }
    repaint();
  });
  const watch = () => {
    document.querySelectorAll('[data-v2-ship], [data-v2-cart-ship], [data-v2-cart-list]').forEach(el =>
      mo.observe(el, {childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden']}));
  };

  function toast(text) {
    const el = document.querySelector('[data-v2-toast]');
    if (!el) return;
    el.innerHTML = `<span class="v2-toast__t"><b>Shipping's on us.</b><span>${esc(text)}</span></span>`;
    el.classList.remove('is-on'); void el.offsetWidth; el.classList.add('is-on');
    setTimeout(() => el.classList.remove('is-on'), 4800);
  }

  function grant() {
    store.set(KEY, '1');
    store.set(SUB, '1'); // le pop-up email ne revient plus
    paint();
    return apply();
  }

  /* Formulaires d'inscription Shopify (form_type=customer) : on ouvre le droit sur l'appareil, sans bloquer l'envoi.
     08/10 : l'ancien envoi forcé (preventDefault puis submit natif) sautait le jeton hCaptcha que Shopify ajoute à l'envoi,
     d'où la page « Missing CAPTCHA token ». Le code est ajouté au panier au chargement suivant (apply). */
  /* 11/10 (audit SEO) : le droit n'est plus ouvert à l'envoi mais au retour confirmé (snippets/rok-waitlist.liquid). */

  /* Pop-up « Shipping's on us. » : en plus du minutage de rok-v2.js (12 s après l'arrivée), deux moments où l'offre tombe juste :
     l'intention de sortie sur ordinateur, et la 2e page vue (le visiteur s'intéresse). Une fois par session, jamais si le droit
     est déjà ouvert, jamais par-dessus le sélecteur, le sac, le menu ou le comparateur. */
  const pop = document.querySelector('[data-v2-pop]');
  const sess = {
    get: k => { try { return sessionStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch {} }
  };
  const busy = () => document.querySelector('[data-v2-pick-panel].is-open, [data-v2-cart].is-open, .v2-menu.is-open, [data-rc-modal][open], [data-v2-pop].is-open');
  function showPop(why) {
    if (!pop || on() || sess.get('rok-pop-shown') || busy()) return false;
    pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
    sess.set('rok-pop-shown', why); store.set('rok-v2-pop', String(Date.now()));
    setTimeout(() => pop.querySelector('input[type="email"]')?.focus({preventScroll: true}), 450);
    return true;
  }
  if (pop) {
    // rok-v2.js ouvre le pop-up de son côté : on le note pour la session
    new MutationObserver(() => { if (pop.classList.contains('is-open')) sess.set('rok-pop-shown', sess.get('rok-pop-shown') || 'timer'); })
      .observe(pop, {attributes: true, attributeFilter: ['class']});
    // Clic sur le voile (hors de la carte) : ferme
    document.addEventListener('pointerdown', e => {
      if (pop.classList.contains('is-open') && !pop.contains(e.target)) pop.querySelector('[data-v2-pop-close]')?.click();
    });
    // 12/10 (Enzo) : déclenchements 2e page et sortie retirés ; seul rok-v2.js décide (fiche produit, bas de l'accueil)
  }

  /* Arrivée par le lien de l'email de bienvenue, ou retour après inscription */
  const url = new URL(location.href);
  const fromLink = url.searchParams.get('livraison') === 'offerte';
  if (fromLink) {
    url.searchParams.delete('livraison');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }
  const start = () => {
    paint(); watch();
    if (fromLink) grant().then(() => toast(D.t.toastOn));
    else {
      apply();
      // Liste d'attente (rok-waitlist.liquid) : sa propre confirmation remplace ce message
      if (on() && /customer_posted=true/.test(location.search) && !document.getElementById('rok-wait-data')) toast(D.t.toastOn);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
